// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__2nQY2","admin":"Message_admin__2a0Yb","email":"Message_email__iyVRj","content":"Message_content__2Hzx4","timestamp":"Message_timestamp__fLCNO"};